function normalizeOption(option) {
  if (option === null || option === undefined) return null;
  if (typeof option === 'string' || typeof option === 'number') {
    const text = String(option).trim();
    return text ? { value: text, label: text } : null;
  }

  const value = String(option.value ?? option.id ?? option.code ?? option.label ?? option.name ?? '').trim();
  if (!value) return null;

  const label = String(option.label ?? option.name ?? option.title ?? value).trim() || value;
  return { value, label };
}

function comparableText(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[_-]+/g, ' ')
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function normalizedOptions(options = []) {
  return options.map(normalizeOption).filter(Boolean);
}

export function getOtherOptionValue(options = []) {
  const other = normalizedOptions(options).find((option) => (
    comparableText(option.value) === 'other' || comparableText(option.label) === 'other'
  ));
  return other?.value ?? 'Other';
}

export function isOtherOptionValue(value, options = []) {
  const selected = comparableText(value);
  if (!selected) return false;
  return selected === comparableText(getOtherOptionValue(options));
}

export function splitOtherOptionValue(rawValue, options = []) {
  const text = String(rawValue ?? '').trim();
  if (!text) {
    return { value: '', otherValue: '' };
  }

  const otherValue = getOtherOptionValue(options);
  const prefixedMatch = text.match(/^other\s*[:\-–]\s*(.+)$/i);
  if (prefixedMatch) {
    return { value: otherValue, otherValue: prefixedMatch[1].trim() };
  }

  const optionsList = normalizedOptions(options);
  const matched = optionsList.find((option) => (
    comparableText(option.value) === comparableText(text) ||
    comparableText(option.label) === comparableText(text)
  ));

  if (matched) {
    return {
      value: matched.value,
      otherValue: '',
    };
  }

  if (/^other\b/i.test(text)) {
    return { value: otherValue, otherValue: text.replace(/^other\s*/i, '').replace(/^[:\-–]\s*/, '').trim() };
  }

  return { value: text, otherValue: '' };
}

export function formatOtherOptionValue(value, otherValue, options = []) {
  const text = String(value ?? '').trim();
  if (!text) return '';

  if (isOtherOptionValue(text, options)) {
    const detail = String(otherValue ?? '').trim();
    return detail ? `Other: ${detail}` : 'Other';
  }

  return text;
}

